<script>
    import Autocomplete from '@smui-extra/autocomplete';
    import { Text } from '@smui/list';
    import CircularProgress from '@smui/circular-progress';
    import Icon from '@smui/select/icon';

    export let toExtent;

    let locations = [];
    let value = undefined;

    let counter = 0;
 
    async function searchItems(input, res) {
        if (input === '' || input.length < 3) {
            return [];
        }
        const myCounter = ++counter;

        console.log(input, value)
        
        const response = await fetch(`https://nominatim.openstreetmap.org/search?q=${input}&format=json`);
        const movies = await response.json();
        console.log(movies);
        const responseLocations = movies.map(movie => {
            return {
                id: movie.place_id,
                title: movie.display_name,
                subtitle: movie.osm_type,
                boundingbox: movie.boundingbox,
                lat: movie.lat,
                lng: movie.lon,
                zoom: 16
            }
        });
        

        if (myCounter !== counter) return false;

        return locations = [...responseLocations];

        /*return locations.filter((item) =>
            item.toLowerCase().includes(input.toLowerCase())
        );*/

    }
    const select = (newValue) => {
        if(typeof newValue !== 'object' || !newValue.boundingbox) return false;
        //const extent = [newValue.boundingbox[0], newValue.boundingbox[2], newValue.boundingbox[1], newValue.boundingbox[3]];
        const extent = [newValue.boundingbox[2], newValue.boundingbox[0], newValue.boundingbox[3], newValue.boundingbox[1]];
        toExtent(extent);
    }
    $: select(value)
</script>

<div class="ge-osm-search">
    <Autocomplete
      search={searchItems}
      bind:value
      getOptionLabel={(option) => option ? `${option.title}` : ''}
      showMenuWithNoInput={true}
      label="Search Location"
      textfield$variant="filled"
    >
        <Icon class="material-icons" slot="leadingIcon">event</Icon>
        <Text
            slot="loading"
            style="display: flex; width: 100%; justify-content: center; align-items: center;"
        >
            <CircularProgress style="height: 24px; width: 24px;" indeterminate />
        </Text>
    </Autocomplete>
</div>

<style>
    :global(.ge-osm-search .mdc-text-field--filled::before){
        height: 30px
    }
</style>